/**
Author - Shreshtha Sharma
Git - https://github.com/shreshtha-wealthy
**/

import React from "react";
import styled from "styled-components";
import parseHtmlContent from "helpers/parseHtmlContent";

import { colors } from "nxtconstants";
import { WealthyEnv } from "helpers";

import { SectionTitle, container } from "../common";
import dematChargesBDSA from "./constant";

const diamondRuppeeIcon = `url(${WealthyEnv.BROKING_CDN_URL}/diamond-ruppee-icon.png)`;

const BrokerageCharges = () => {
  const loadDematChargesBDSA = dematChargesBDSA.map((dataItem, rowIndex) => (
    <DataRow key={rowIndex}>
      <DataItem className="small-items">{parseHtmlContent(dataItem[0])}</DataItem>
      <DataItem>{parseHtmlContent(dataItem[1])}</DataItem>
    </DataRow>
  ));

  return (
    <>
      <ChargesWrapper>
        <SectionTitle>**Important Guidelines</SectionTitle>
        <Note>
          1. The charges shown here are based on one of the available brokerage plans. These plans may vary depending on the option selected during the KYC onboarding process. For Equity Delivery/Intraday trades, charges are ₹15 or 0.1% per order, whichever is lower(one of our brokerage plan).
          2. The brokerage charged to your trading account will always remain within the maximum limits allowed under the rules, regulations, and bye-laws of the relevant stock exchanges, as well as the guidelines set by SEBI. 
          3. Wealthy IN Broking retains the absolute discretion to modify, amend, or discontinue the offer and its terms and conditions at any time. Any changes will be communicated to clients via email.
        </Note>
      </ChargesWrapper>
      <ChargesWrapper>
        <SectionTitle>*Annual Maintenance Charges (For BSDA Account)</SectionTitle>
        <Table>{loadDematChargesBDSA}</Table>
        <Note>
          Note – Charges applicable will be deducted on a quarterly basis.
        </Note>
      </ChargesWrapper>
    </>
  );
};

const ChargesWrapper = styled(container)`
  padding-top: 5rem;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: -90px;
    right: -100px;
    z-index: -1;
    width: 157px;
    height: 163px;
    background-image: ${diamondRuppeeIcon};
    background-size: contain;
    background-repeat: no-repeat;
  }

  @media (max-width: 1300px) {
    &::after {
      right: 0;
    }
  }

  @media (max-width: 768px) {
    padding-top: 5.2rem;
  }
`;

const Table = styled.div`
  border-radius: 1.5rem;
  overflow: hidden;
  margin-top: 4.4rem;
  padding: 1.7rem 3rem;
  border: 2px solid rgba(126, 126, 126, 0.2);
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(6.5px);

  @media (max-width: 768px) {
    margin-top: 3.2rem;
    padding: 1rem 2rem;
  }
`;

const DataRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 2.4rem;
  padding: 2rem 3.2rem;
  border-bottom: 1px solid #ddd;

  &:last-child {
    border: 0;
  }

  h3 {
    font-size: 2rem;
  }

  span {
    color: ${colors.black};
    font-size: 2rem;
    font-weight: bold;
  }

  small {
    font-size: 1.6rem;
  }

  @media (max-width: 768px) {
    padding: 3rem 1rem;
    font-size: 1.6rem;

    & > div {
      text-align: left;
      width: 50%;
    }

    & > div:nth-child(2) {
      text-align: right;
    }

    small {
      font-size: 1rem;
      line-height: 1.6;
      display: block;
    }
  }
`;

const DataItem = styled.div`
  text-align: right;

  @media (max-width: 768px) {
    .small-items {
      font-size: 1.4rem;
    }
    span {
      font-size: 1.6rem;
    }

    small {
      font-size: 1.3rem;
    }
  }
`;

const Note = styled.div`
  font-size: 1.6rem;
  margin-top: 2rem;
  color: ${colors.gray};

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

export default BrokerageCharges;
